import type { PartSvgProps } from './types'

export default function BcgSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  accent = 'var(--gs-part-accent, #E85D04)',
  width = 120,
  height = 120
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 120 120" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Carrier body */}
      <rect x="14" y="28" width="92" height="64" rx="6"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Carrier key bump — top center */}
      <rect x="46" y="14" width="28" height="18" rx="3"
            fill={fill} stroke={accent} strokeWidth="1.2" />
      {/* Cam pin hole */}
      <circle cx="60" cy="60" r="10" fill="none" stroke={accent} strokeWidth="1.5" />
      {/* Firing pin retainer hole suggestion */}
      <circle cx="96" cy="60" r="4" fill="none" stroke={stroke} strokeWidth="1" />
      {/* Bolt face recess */}
      <circle cx="24" cy="60" r="8" fill="none" stroke={stroke} strokeWidth="1.2" />
      {/* Extractor lug */}
      <rect x="14" y="52" width="8" height="16" rx="1"
            fill={fill} stroke={stroke} strokeWidth="1" />
    </svg>
  )
}
